import { defineTokens } from "@chakra-ui/react";

export const fontsToken = defineTokens.fonts({
    heading: { value: "Noto Sans Armenian, sans-serif" },
    body: { value: "Noto Sans Armenian, sans-serif" },
});
